import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import './home.scss';
import { Carousel, Select, Tooltip, Skeleton } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import http from '@/server';
import { Context } from '@/models/home';
import AD from '@/components/AD';

const { Option } = Select;

function Home() {
  let history = useHistory();
  const HomeContext = useContext(Context);
  const carousel = useRef(null);
  useEffect(() => {
    const carousel = document.getElementsByClassName('cmain')[0];
    const leftBtn = document.getElementsByClassName('anticon-left')[0];
    const rightBtn = document.getElementsByClassName('anticon-right')[0];
    carousel.addEventListener('mouseenter', () => {
      leftBtn.style.opacity = '1';
      leftBtn.style.left = '15px';
      rightBtn.style.opacity = '1';
      rightBtn.style.right = '15px';
    });
    carousel.addEventListener('mouseleave', () => {
      leftBtn.style.opacity = '0';
      leftBtn.style.left = '5px';
      rightBtn.style.opacity = '0';
      rightBtn.style.right = '5px';
    });
    return () => { };
  }, []);

  useEffect(() => {
    const tabs1 = [...document.querySelectorAll('.bzh .tab span')];
    tabs1.map((item) => {
      item.addEventListener('click', () => {
        tabs1.map((i) => {
          i.classList.remove('tabAtv');
          return null;
        });
        item.classList.add('tabAtv');
      });
      return null;
    });
    const tabs2 = [...document.querySelectorAll('.kpyd .tab span')];
    tabs2.map((item) => {
      item.addEventListener('click', () => {
        tabs2.map((i) => {
          i.classList.remove('tabAtv');
          return null;
        });
        item.classList.add('tabAtv');
      });
      return null;
    });
    const tabs3 = [...document.querySelectorAll('.jstx .tab span')];
    tabs3.map((item) => {
      item.addEventListener('click', () => {
        tabs3.map((i) => {
          i.classList.remove('tabAtv');
          return null;
        });
        item.classList.add('tabAtv');
      });
      return null;
    });

    let intVId = '';
    const kjfwImgs = document.getElementById('kjfwImgs');
    // const htmls = document.querySelectorAll('.lis')[0].cloneNode(true);
    // kjfwImgs.appendChild(htmls);
    kjfwImgs.addEventListener('mouseenter', () => {
      clearInterval(intVId);
    });
    kjfwImgs.addEventListener('mouseleave', () => {
      intVId = setInterval(() => {
        if (
          i >= 0 &&
          document.querySelectorAll('.lis') &&
          document.querySelectorAll('.lis')[0] &&
          i < document.querySelectorAll('.lis')[0].scrollWidth
        ) {
          i += 1;
          kjfwImgs.style.left = -i + 'px';
        } else {
          i = 0;
          kjfwImgs.style.left = -i + 'px';
        }
      }, 50);
    });
    kjfwImgs.style.position = 'absolute';
    let i = 0;
    intVId = setInterval(() => {
      if (
        i >= 0 &&
        document.querySelectorAll('.lis') &&
        document.querySelectorAll('.lis')[0] &&
        i < document.querySelectorAll('.lis')[0].scrollWidth
      ) {
        i += 1;
        kjfwImgs.style.left = -i + 'px';
      } else {
        i = 0;
        kjfwImgs.style.left = -i + 'px';
      }
    }, 50);

    const leftBtn = document.querySelectorAll('.leftBtn')[0];
    const rightBtn = document.querySelectorAll('.rightBtn')[0];
    leftBtn.addEventListener('click', () => {
      if (i < 215) {
        i = document.querySelectorAll('.lis')[0].scrollWidth;
      } else {
        i = i - 215;
      }
    });
    rightBtn.addEventListener('click', () => {
      i = i + 215;
    });

    return () => {
      clearInterval(intVId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [inV, setinV] = useState();

  useEffect(() => {
    window.sessionStorage.setItem('page', 1);
    return () => {
      clearInterval(inV);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const topHD = useCallback((list) => {
    const hotUl = document.querySelector('.topHot ul');
    let i = 0;
    let inV = setInterval(() => {
      i += 1;
      hotUl.style.transition = 'all ease 1s';
      hotUl.style.transform = 'translateY(' + -i * 40 + 'px)';
      if (i === list.length) {
        hotUl.style.transition = 'all ease 0s';
        hotUl.style.transform = 'translateY(0px)';
        i = 0;
      }
    }, 5000);
    setinV(inV);
  }, [setinV]);


  const [xhdtList, setxhdtList] = useState();
  const [gglList, setgglList] = useState();
  const [qyjsList, setqyjsList] = useState();
  const [hyywList, sethyywList] = useState();
  const [hydtList, sethydtList] = useState();
  const [fgyzcList, setfgyzcList] = useState();
  const [bzhList, setbzhList] = useState();
  // const [kjfwList, setkjfwList] = useState();
  const [kxydList, setkxydList] = useState();
  const [jstxList, setjstxList] = useState();
  // const [gyxhList, setgyxhList] = useState();
  const [wzggList, setwzggList] = useState();
  const [menusList, setMenusList] = useState();
  const [linksData1, setLinksData1] = useState();
  const [linksData2, setLinksData2] = useState();
  const [linksData3, setLinksData3] = useState();
  const [slideData1, setSlideData1] = useState();
  const [slideData2, setSlideData2] = useState([]);
  const [jstx, setjstx] = useState('jqml');
  const [bzh, setbzh] = useState('ttbz');
  const [kpyd, setkpyd] = useState('kpzp');
  const [timeoutId, setTimeoutId] = useState();

  // 获取幻灯片类型
  const slideType = useCallback(() => {
    let params = {};
    http.get('/slide/achieve_category', params).then((res) => {
      res.data.data.map((item) => {
        if (item.title === '首页-科技服务') {
          params = {
            page: '',
            pageSize: '',
            cid: item.id,
          };
          http.get('/slide/achieve_slide', params).then((res) => {
            setSlideData2(res.data.data);
          });
        } else if (item.title === '首页-顶部轮播') {
          params = {
            page: '',
            pageSize: '',
            cid: item.id,
          };
          http.get('/slide/achieve_slide', params).then((res) => {
            setSlideData1(res.data.data);
            let timeout = setTimeout(() => {
              let kjfwImgs = document.getElementById('kjfwImgs');
              const htmls =
                document.querySelectorAll('.lis')[0] &&
                document.querySelectorAll('.lis')[0].cloneNode(true);
              kjfwImgs && kjfwImgs.appendChild(htmls);
            }, 500);
            setTimeoutId(timeout);
          });
        }
        return null;
      });
    });
  }, [setTimeoutId]);

  // 获取友情链接分组
  const getLinksTypeList = useCallback(() => {
    let params = {};
    http.get('/links/achieve_category', params).then((res) => {
      // setLinks(res.data.data);
      res.data.data.map((item) => {
        switch (item.title) {
          case '国内通信相关网站':
            params = {
              page: '',
              pageSize: '',
              cid: item.id,
            };
            http.get('/links/achieve_links', params).then((res) => {
              setLinksData1(res.data.data);
            });
            break;
          case '省内相关网站':
            params = {
              page: '',
              pageSize: '',
              cid: item.id,
            };
            http.get('/links/achieve_links', params).then((res) => {
              setLinksData2(res.data.data);
            });
            break;
          case '其他相关网站':
            params = {
              page: '',
              pageSize: '',
              cid: item.id,
            };
            http.get('/links/achieve_links', params).then((res) => {
              setLinksData3(res.data.data);
            });
            break;

          default:
            break;
        }
        return null;
      });
    });
  }, []);

  // 获取新闻分类列表
  // const getNewsTypeList = () => {
  //   let params = {
  //     pid: '',
  //   };
  //   http.get('/news/achieve_news_category', params).then((res) => {
  //     setNewsTypeList(res.data.data);
  //     HomeContext.dispatch({
  //       type: 'SET_NEWSTYPELIST',
  //       payload: {
  //         data: res.data.data,
  //       },
  //     });
  //   });
  // };

  // 获取栏目列表数据
  const getListData = useCallback(() => {
    let menuLists = HomeContext.state.menuList;
    // if (!menuLists) {
    //   window.location.reload();
    // }
    Object.keys(menuLists).map((i) => {
      menuLists[i].map((item) => {
        let params = {
          page: 1,
          pageSize: 6,
          cid: '',
          title: '',
        };
        switch (item.title) {
          case 'xhdt':
            params.pageSize = 8;
            params.cid = item.id;
            http.get('/news/achieve_news_by_cid', params).then((res) => {
              setxhdtList(res.data.data);
            });
            break;
          case 'ggl':
            params.pageSize = 9;
            params.cid = item.id;
            http.get('/news/achieve_news_by_cid', params).then((res) => {
              setgglList(res.data.data);
            });
            break;
          case 'qyjs':
            params.pageSize = 9;
            params.cid = item.id;
            http.get('/news/achieve_news_by_cid', params).then((res) => {
              setqyjsList(res.data.data);
            });
            break;
          case 'hyyw':
            params.pageSize = 9;
            params.cid = item.id;
            http.get('/news/achieve_news_by_cid', params).then((res) => {
              sethyywList(res.data.data);
            });
            break;
          case 'fgyzc':
            params.pageSize = 9;
            params.cid = item.id;
            http.get('/news/achieve_news_by_cid', params).then((res) => {
              setfgyzcList(res.data.data);
            });
            break;
          case 'hydt':
            params.pageSize = 7;
            params.cid = item.id;
            http.get('/news/achieve_news_by_cid', params).then((res) => {
              sethydtList(res.data.data);
            });
            break;
          // case '科技服务':
          //   params.pageSize = 10;
          //   params.cid = item.id;
          //   http.get('/news/achieve_news_by_cid', params).then((res) => {
          //     setkjfwList(res.data.data);
          //   });
          //   break;
          // case '关于学会':
          //   params.pageSize = 6;
          //   params.cid = item.id;
          //   let data = {
          //     pid: item.id,
          //   };
          //   http.get('/news/achieve_news_category', data).then((resoponse) => {
          //     setgyxhList(resoponse.data.data);
          //   });
          //   break;
          default:
            break;
        }
        return null;
      });
      return null;
    });

    let menus = HomeContext.state.menuList;
    let params = {
      page: 1,
      pageSize: 8,
      cid: '',
      title: '',
    };
    menus['bzh'].map((item) => {
      switch (item.title) {
        case 'ttbz':
          params.pageSize = 8;
          params.cid = item.id;
          http.get('/news/achieve_news_by_cid', params).then((res) => {
            setbzhList(res.data.data);
          });
          break;

        default:
          break;
      }
      return null;
    });
    menus['kpyd'].map((item) => {
      switch (item.title) {
        case 'kpzp':
          params.pageSize = 8;
          params.cid = item.id;
          http.get('/news/achieve_news_by_cid', params).then((res) => {
            setkxydList(res.data.data);
          });
          break;

        default:
          break;
      }
      return null;
    });
    menus['jstx'].map((item) => {
      switch (item.title) {
        case 'jqml':
          params.pageSize = 2;
          params.cid = item.id;
          http.get('/news/achieve_news_by_cid', params).then((res) => {
            setjstxList(res.data.data);
          });
          break;
        default:
          break;
      }
      return null;
    });
    // let menus =
    //   HomeContext.state.menuList ||
    //   JSON.parse(window.localStorage.getItem('menuList'));
    // newsTypeList &&
    //   newsTypeList.map((item) => {
    //     let params = {
    //       page: 1,
    //       pageSize: 6,
    //       cid: '',
    //       title: '',
    //     };
    //     switch (item.name) {
    //       case '标准化':
    //         params.pageSize = 6;
    //         params.cid = item.id;
    //         http.get('/news/achieve_news_by_cid', params).then((res) => {
    //           setbzhList(res.data.data);
    //         });
    //         menus['标准化'] &&
    //           menus['标准化'].push({
    //             name: '标准化',
    //             id: item.id,
    //             path: `/list?title=${item.name}/标准化&id=${item.id}`,
    //           });
    //         break;
    //       case '科普园地':
    //         params.pageSize = 6;
    //         params.cid = item.id;
    //         http.get('/news/achieve_news_by_cid', params).then((res) => {
    //           setkxydList(res.data.data);
    //         });
    //         menus['科普园地'] &&
    //           menus['科普园地'].push({
    //             name: '科普园地',
    //             id: item.id,
    //             path: `/list?title=${item.name}/科普园地&id=${item.id}`,
    //           });
    //         break;
    //       case '《江苏通信》':
    //         params.pageSize = 6;
    //         params.cid = item.id;
    //         http.get('/news/achieve_news_by_cid', params).then((res) => {
    //           setjstxList(res.data.data);
    //         });
    //         menus['《江苏通信》'] &&
    //           menus['《江苏通信》'].push({
    //             name: '《江苏通信》',
    //             id: item.id,
    //             path: `/list?title=${item.name}/《江苏通信》&id=${item.id}`,
    //           });
    //         break;
    //       default:
    //         break;
    //     }
    //   });
    setMenusList(HomeContext.state.menuList);
  }, [HomeContext.state.menuList]);

  // 获取网站公告
  const getWzggList = useCallback(() => {
    let params = {
      page: 1,
      pageSize: 10,
    };
    http.get('/newgg/achieve_news', params).then((res) => {
      setwzggList(res.data.data);
      topHD(res.data.data);
    });
  }, [topHD]);

  useEffect(() => {
    // getNewsTypeList();
    getLinksTypeList();
    slideType();
    getWzggList();
    // if (!window.localStorage.getItem('menuList')) {
    //   window.location.reload();
    // }
    return () => {
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getLinksTypeList, slideType, getWzggList]);

  useEffect(() => {
    getListData();
  }, [HomeContext.state.menuList, getListData]);

  const queryId = useCallback((name, title) => {
    let menus = HomeContext.state.menuList;
    let params = {
      page: 1,
      pageSize: 8,
      cid: '',
      title: '',
    };
    menus &&
      Object.keys(menus).length > 0 &&
      menus[name].map((item) => {
        switch (item.title) {
          case title:
            params.pageSize = 8;
            params.cid = item.id;
            http.get('/news/achieve_news_by_cid', params).then((res) => {
              switch (name) {
                case 'bzh':
                  setbzhList(res.data.data);
                  break;
                case 'kpyd':
                  // console.log(res);
                  setkxydList(res.data.data);
                  break;
                case 'jstx':
                  setjstxList(res.data.data);
                  break;

                default:
                  break;
              }
            });
            break;

          default:
            break;
        }
        return null;
      });
  }, [HomeContext.state.menuList]);

  useEffect(() => {
    queryId('bzh', bzh);
  }, [bzh, queryId]);

  useEffect(() => {
    queryId('jstx', jstx);
  }, [jstx, queryId]);

  useEffect(() => {
    queryId('kpyd', kpyd);
  }, [kpyd, queryId]);

  const handleChange = (value) => {
    window.open(value);
  };

  const toQuick = (title) => {
    HomeContext.state.menuList &&
      Object.keys(HomeContext.state.menuList).map((i) => {
        HomeContext.state.menuList[i].map((item) => {
          if (item.title === title) {
            history.push(item.path);
          }
          return null;
        });
        return null;
      });
  };

  const toRouter = (path, data) => {
    console.log(path, data);
    if (data.link_url) return window.open(data.link_url);
    // return console.log(data);
    if (data.cid === 10086) {
      return history.push(
        `/${path}?title=网站公告&id=${data.id}&cid=${data.cid}`,
      );
    }
    let menus = HomeContext.state.menuList;
    let titleType = HomeContext.state.menuTitleList;
    menus &&
      Object.keys(menus).map((i) => {
        menus[i].map((item) => {
          if (item.title === titleType[data.cname]) {
            history.push(
              `/${path}?title=${i}/${titleType[data.cname]}&id=${data.id}&cid=${data.cid
              }`,
            );
          }
          return null;
        });
        return null;
      });
  };

  // eslint-disable-next-line no-unused-vars
  const alink = (path, data) => {
    if (data.cid === 10086) {
      return `/${path}?title=网站公告&id=${data.id}&cid=${data.cid}`;
    }
    let menus = HomeContext.state.menuList;
    let titleType = HomeContext.state.menuTitleList;
    if (menus) {
      for (let i in menus) {
        for (let item of menus[i]) {
          if (item.title === titleType[data.cname]) {
            return `/${path}?title=${i}/${titleType[data.cname]}&id=${data.id}&cid=${data.cid}`;
          }
        }
      }
    }
    // 默认返回一个有效的链接
    return `/${path}?title=zxzx/xhdt&id=${data.id}&cid=${data.cid}`;
  };

  const toId = (name) => {
    let menus =
      HomeContext.state.menuList ||
      JSON.parse(window.localStorage.getItem('menuList'));
    if (name === 'bzh' || name === 'kpyd' || name === 'jstx') {
      menus[name].map((item) => {
        if (item.title === bzh || item.title === jstx || item.title === kpyd) {
          return history.push(item.path);
        }
        return null;
      });
      return;
    }
    menusList &&
      Object.keys(menusList).map((i) => {
        menusList[i].map((item) => {
          if (item.name === name) {
            history.push(item.path);
          } else if (item.title === name) {
            history.push(item.path);
          }
          return null;
        });
        return null;
      });
  };

  return (

    <div>
      <AD />
      <div className="topHot">
        <img src={require('@/assets/home/gg.png').default} alt=''></img>{' '}
        <span>【网站公告】</span>
        <span>
          <ul>
            {wzggList && wzggList.length > 0 ? (
              wzggList.map((item, index) => {
                return (
                  <li
                    key={index}
                    onClick={() => {
                      window.location = item.link_before;
                    }}
                  >
                    {item.title} [{item.create_time.substring(5, 10)}]
                  </li>
                );
              })
            ) : (
              <Skeleton active paragraph={{ rows: 1 }} />
            )}
          </ul>
        </span>
      </div>
      <div className="xhdt center">
        <ul className="clearfix cul">
          <li className="cmain">
            <LeftOutlined
              onClick={() => {
                carousel.current.prev();
              }}
            />
            <Carousel effect="fade" autoplay ref={carousel}>
              {slideData1 && slideData1.length > 0 ? (
                slideData1.map((item, index) => {
                  return (
                    <div key={index}>
                      <span className="c-title">{item.title}</span>
                      <img
                        onClick={() => {
                          window.location.href = item.url;
                        }}
                        src={item.pic_url}
                        alt=""
                      ></img>
                    </div>
                  );
                })
              ) : (
                <Skeleton.Image active />
              )}
            </Carousel>
            <RightOutlined
              onClick={() => {
                carousel.current.next();
              }}
            />
          </li>
          <li className="cmain">
            <div className="title clearfix">
              <div>学会动态</div>
              <span onClick={toId.bind(this, 'xhdt')}>
                更多
                <RightOutlined />
                <RightOutlined />
              </span>
            </div>
            {HomeContext.state.isMobile ? (
              <h1
                onClick={toRouter.bind(this, 'detail', xhdtList && xhdtList[0])}
              >
                {xhdtList ? (
                  xhdtList[0].title
                ) : (
                  <Skeleton.Input
                    style={{ width: 400 }}
                    active
                    size="default"
                  />
                )}
              </h1>
            ) : (

              <Tooltip placement="top" title={xhdtList && xhdtList[0].title}>
                {/* <h1
                  onClick={toRouter.bind(
                    this,
                    'detail',
                    xhdtList && xhdtList[0],
                  )}
                >
                  {xhdtList ? (
                    xhdtList[0].title
                  ) : (
                    <Skeleton.Input
                      style={{ width: 400 }}
                      active
                      size="default"
                    />
                  )}
                </h1> */}


                {xhdtList ? (
                  <a
                    className="newA"
                    href={
                      xhdtList[0].link_url
                        ? xhdtList[0].link_url
                        : `/detail?title=zxzx/xhdt&id=${xhdtList[0].id}&cid=${xhdtList[0].cid}`
                    }
                    dangerouslySetInnerHTML={{ __html: xhdtList[0].title }}
                  >
                  </a>
                ) : (
                  <Skeleton.Input
                    style={{ width: 400 }}
                    active
                    size="default"
                  />
                )}



              </Tooltip>
            )}
            <ul className="newList">
              {xhdtList ? (
                xhdtList.map((item, index) => {
                  return index > 0 ? (
                    HomeContext.state.isMobile ? (
                      <li
                        className="clearfix"
                        onClick={toRouter.bind(this, 'detail', item)}
                      >
                        <span>
                          <b></b>
                          <div>{item.title}</div>
                        </span>
                      </li>
                    ) : (
                      <Tooltip placement="top" title={item.title} key={index}>
                        <li
                          className="clearfix"
                          // onClick={toRouter.bind(this, 'detail', item)}
                        >
                          <span>
                            <b></b>
                            {/* <div>{item.title}</div> */}
                            <a className='newsAA'
                              href={
                                item.link_url
                                  ? item.link_url
                                  : `/detail?title=zxzx/xhdt&id=${item.id}&cid=${item.cid}`
                              }
                              dangerouslySetInnerHTML={{ __html: item.title }}
                            >

                            </a>
                          </span>
                        </li>
                      </Tooltip>
                    )
                  ) : null;
                })
              ) : (
                <Skeleton active paragraph={{ rows: 6 }} />
              )}
            </ul>
          </li>
          <li className="cmain">
            <div className="title clearfix">
              <div>公告栏</div>
              <span onClick={toId.bind(this, 'ggl')}>
                更多
                <RightOutlined />
                <RightOutlined />
              </span>
            </div>
            <ul className="newList">
              {gglList ? (
                gglList.map((item, index) => {
                  return HomeContext.state.isMobile ? (
                    <li
                      className="clearfix"
                      onClick={toRouter.bind(this, 'detail', item)}
                    >
                      <span>
                        <b></b>
                        <div>{item.title}</div>
                      </span>
                    </li>
                  ) : (
                    <Tooltip placement="top" title={item.title} key={index}>
                      <li
                        className="clearfix"
                        // onClick={toRouter.bind(this, 'detail', item)}
                      >
                        <span>
                          <b></b>
                          {/* <div>{item.title}</div> */}
                          <a className='newsAA'
                            href={
                              item.link_url
                                ? item.link_url
                                : `/detail?title=zxzx/ggl&id=${item.id}&cid=${item.cid}`
                            }
                            dangerouslySetInnerHTML={{ __html: item.title }}
                          >

                          </a>
                        </span>
                      </li>
                    </Tooltip>
                  );
                })
              ) : (
                <Skeleton active paragraph={{ rows: 8 }} />
              )}
            </ul>
          </li>
        </ul>
      </div>
      <div className="titleImg center">
        <img src={require('@/assets/home/2.png').default} alt=''></img>
      </div>
      <div className="main center clearfix">
        <div className="leftBox clearfix">
          <div className="listBox">
            <div className="ml-title clearfix">
              <div className="title-qzjs">前瞻技术</div>
              <span onClick={toId.bind(this, 'qyjs')}>
                更多
                <RightOutlined />
                <RightOutlined />
              </span>
            </div>
            <ul className="newList">
              {qyjsList ? (
                qyjsList.map((item, index) => {
                  return HomeContext.state.isMobile ? (
                    <li
                      className="clearfix"
                      onClick={toRouter.bind(this, 'detail', item)}
                    >
                      <span>
                        <b></b>
                        <div>{item.title}</div>
                      </span>
                    </li>
                  ) : (
                    <Tooltip placement="top" title={item.title} key={index}>
                      <li
                        className="clearfix"
                        // onClick={toRouter.bind(this, 'detail', item)}
                      >
                        <span>
                          <b></b>
                          {/* <div>{item.title}</div> */}
                          <a className='newsAA'
                            href={
                              item.link_url
                                ? item.link_url
                                : `/detail?title=xsygh/qyjs&id=${item.id}&cid=${item.cid}`
                            }
                            dangerouslySetInnerHTML={{ __html: item.title }}
                          >

                          </a>
                        </span>
                      </li>
                    </Tooltip>
                  );
                })
              ) : (
                <Skeleton active paragraph={{ rows: 8 }} />
              )}
            </ul>
          </div>
          <div className="listBox">
            <div className="ml-title clearfix">
              <div className="title-hyyw">行业要闻</div>
              <span onClick={toId.bind(this, 'hyyw')}>
                更多
                <RightOutlined />
                <RightOutlined />
              </span>
            </div>
            <ul className="newList">
              {hyywList ? (
                hyywList.map((item, index) => {
                  return HomeContext.state.isMobile ? (
                    <li
                      className="clearfix"
                      onClick={toRouter.bind(this, 'detail', item)}
                    >
                      <span>
                        <b></b>
                        <div>{item.title}</div>
                      </span>
                    </li>
                  ) : (
                    <Tooltip placement="top" title={item.title} key={index}>
                      <li
                        className="clearfix"
                        // onClick={toRouter.bind(this, 'detail', item)}
                      >
                        <span>
                          <b></b>
                          {/* <div>{item.title}</div> */}
                          <a className='newsAA'
                            href={
                              item.link_url
                                ? item.link_url
                                : `/detail?title=xsygh/hyyw&id=${item.id}&cid=${item.cid}`
                            }
                            dangerouslySetInnerHTML={{ __html: item.title }}
                          >
                          </a>
                        </span>
                      </li>
                    </Tooltip>
                  );
                })
              ) : (
                <Skeleton active paragraph={{ rows: 8 }} />
              )}
            </ul>
          </div>
          <div className="listBox">
            <div className="ml-title clearfix">
              <div className="title-fgyzc">法规与政策</div>
              <span onClick={toId.bind(this, 'fgyzc')}>
                更多
                <RightOutlined />
                <RightOutlined />
              </span>
            </div>
            <ul className="newList">
              {fgyzcList ? (
                fgyzcList.map((item, index) => {
                  return HomeContext.state.isMobile ? (
                    <li
                      className="clearfix"
                      onClick={toRouter.bind(this, 'detail', item)}
                    >
                      <span>
                        <b></b>
                        <div>{item.title}</div>
                      </span>
                    </li>
                  ) : (
                    <Tooltip placement="top" title={item.title} key={index}>
                      <li
                        className="clearfix"
                        // onClick={toRouter.bind(this, 'detail', item)}
                      >
                        <span>
                          <b></b>
                          {/* <div>{item.title}</div> */}
                          <a className='newsAA'
                            href={
                              item.link_url
                                ? item.link_url
                                : `/detail?title=xsygh/fgyzc&id=${item.id}&cid=${item.cid}`
                            }
                            dangerouslySetInnerHTML={{ __html: item.title }}
                          >
                          </a>
                        </span>
                      </li>
                    </Tooltip>
                  );
                })
              ) : (
                <Skeleton active paragraph={{ rows: 8 }} />
              )}
            </ul>
          </div>
          <div className="listBox bzh">
            <div className="ml-title clearfix">
              <div className="title-bzh">标准化</div>
              <span onClick={toId.bind(this, 'bzh')}>
                更多
                <RightOutlined />
                <RightOutlined />
              </span>
            </div>
            <div className="tab">
              <span
                className="tabAtv"
                onClick={() => {
                  setbzh('ttbz');
                }}
              >
                团体标准
              </span>
              <span
                onClick={() => {
                  setbzh('dfbz');
                }}
              >
                地方标准
              </span>
              <span
                onClick={() => {
                  setbzh('hybz');
                }}
              >
                行业标准
              </span>
              <span
                onClick={() => {
                  setbzh('gjbz');
                }}
              >
                国家标准
              </span>
            </div>
            <ul className="newList">
              {bzhList ? (
                bzhList.map((item, index) => {
                  return HomeContext.state.isMobile ? (
                    <li
                      className="clearfix"
                      onClick={toRouter.bind(this, 'detail', item)}
                    >
                      <span>
                        <b></b>
                        <div>{item.title}</div>
                      </span>
                    </li>
                  ) : (
                    <Tooltip placement="top" title={item.title} key={index}>
                      <li
                        className="clearfix"
                        // onClick={toRouter.bind(this, 'detail', item)}
                      >
                        <span>
                          <b></b>
                          {/* <div>{item.title}</div> */}
                          <a className='newsAA'
                            href={
                              item.link_url
                                ? item.link_url
                                : `/detail?title=bzh/ttbz&id=${item.id}&cid=${item.cid}`
                            }
                            dangerouslySetInnerHTML={{ __html: item.title }}
                          >
                          </a>
                        </span>
                      </li>
                    </Tooltip>
                  );
                })
              ) : (
                <Skeleton active paragraph={{ rows: 8 }} />
              )}
            </ul>
          </div>
          <div className="kjfw">
            <div className="title clearfix">
              <div>科技服务</div>
              <span onClick={toId.bind(this, 'zxyzk')}>咨询与智库</span>
              <span onClick={toId.bind(this, 'kjpj')}>科技评价</span>
            </div>
            <div className="imgSwiper">
              <div className="leftBtn">
                <LeftOutlined />
              </div>
              <div className="swBox">
                <ul id="kjfwImgs" className="clearfix">
                  <div className="lis clearfix">
                    {slideData2 ? (
                      slideData2.length > 0 &&
                      slideData2.map((item, index) => {
                        return (
                          <a href={item.url} key={index}>
                            <img src={item.pic_url} alt="" />
                            <span>{item.title}</span>
                          </a>
                        );
                      })
                    ) : (
                      <Skeleton active paragraph={{ rows: 8 }} />
                    )}
                  </div>
                </ul>
              </div>
              <div className="rightBtn">
                <RightOutlined />
              </div>
            </div>
          </div>
          <div className="listBox kpyd">
            <div className="ml-title clearfix">
              <div className="title-kpyd">科普园地</div>
              <span onClick={toId.bind(this, 'kpyd')}>
                更多
                <RightOutlined />
                <RightOutlined />
              </span>
            </div>
            <div className="tab">
              <span
                className="tabAtv"
                onClick={() => {
                  setkpyd('kpzp');
                }}
              >
                科普作品
              </span>
              <span
                onClick={() => {
                  setkpyd('kpsp');
                }}
              >
                科普视频
              </span>
              <span
                onClick={() => {
                  setkpyd('kpcg');
                }}
              >
                科普场馆
              </span>
            </div>
            <ul className="newList">
              {kxydList ? (
                kxydList.map((item, index) => {
                  return HomeContext.state.isMobile ? (
                    <li
                      className="clearfix"
                      onClick={toRouter.bind(this, 'detail', item)}
                    >
                      <span>
                        <b></b>
                        <div>{item.title}</div>
                      </span>
                    </li>
                  ) : (
                    <Tooltip placement="top" title={item.title} key={index}>
                      <li
                        className="clearfix"
                        // onClick={toRouter.bind(this, 'detail', item)}
                      >
                        <span>
                          <b></b>
                          {/* <div>{item.title}</div> */}
                          <a className='newsAA'
                            href={
                              item.link_url
                                ? item.link_url
                                : `/detail?title=kpyd/kpzp&id=${item.id}&cid=${item.cid}`
                            }
                            dangerouslySetInnerHTML={{ __html: item.title }}
                          >
                          </a>
                        </span>
                      </li>
                    </Tooltip>
                  );
                })
              ) : (
                <Skeleton active paragraph={{ rows: 8 }} />
              )}
            </ul>
          </div>
          <div className="listBox jstx">
            <div className="ml-title clearfix">
              <div className="title-jstx">《江苏通信》</div>
              <span onClick={toId.bind(this, 'jstx')}>
                更多
                <RightOutlined />
                <RightOutlined />
              </span>
            </div>
            <div className="tab">
              <span
                className="tabAtv"
                onClick={() => {
                  setjstx('jqml');
                }}
              >
                近期目录
              </span>
              <span
                onClick={() => {
                  setjstx('zgqs');
                }}
              >
                征稿启事
              </span>
              <span
                onClick={() => {
                  setjstx('lwj');
                }}
              >
                论文集
              </span>
            </div>
            <ul
              className={
                jstx === 'jqml' || jstx === 'lwj' ? 'newList imgUl' : 'newList'
              }
            >
              {jstx === 'jqml' || jstx === 'lwj' ? (
                jstxList ? (
                  jstxList.map((item, index) => {
                    return (
                      <li
                        key={index}
                        className="clearfix"
                        onClick={toRouter.bind(this, 'detail', item)}
                      >
                        <img src={item.pic_url} alt="" />
                        {HomeContext.state.isMobile ? (
                          <span>{item.title}</span>
                        ) : (
                          <Tooltip placement="bottom" title={item.title}>
                            <span>{item.title}</span>
                          </Tooltip>
                        )}
                      </li>
                    );
                  })
                ) : (
                  <Skeleton active paragraph={{ rows: 8 }} />
                )
              ) : jstxList ? (
                jstxList.map((item, index) => {
                  return HomeContext.state.isMobile ? (
                    <li
                      className="clearfix"
                      onClick={toRouter.bind(this, 'detail', item)}
                    >
                      <span>
                        <b></b>
                        <div>{item.title}</div>
                      </span>
                    </li>
                  ) : (
                    <Tooltip placement="top" title={item.title} key={index}>
                      <li
                        className="clearfix"
                        // onClick={toRouter.bind(this, 'detail', item)}
                      >
                        <span>
                          <b></b>
                          {/* <div>{item.title}</div> */}
                          <a className='newsAA'
                            href={
                              item.link_url
                                ? item.link_url
                                : `/detail?title=jstx/zgqs&id=${item.id}&cid=${item.cid}`
                            }
                            dangerouslySetInnerHTML={{ __html: item.title }}
                          >
                          </a>
                        </span>
                      </li>
                    </Tooltip>
                  );
                })
              ) : (
                <Skeleton active paragraph={{ rows: 8 }} />
              )}
            </ul>
          </div>
        </div>
        <div className="rightBox">
          <div className="title clearfix">
            <div>会员动态</div>
            <span onClick={toId.bind(this, 'hydt')}>
              更多
              <RightOutlined />
              <RightOutlined />
            </span>
          </div>
          <ul className="newList">
            {hydtList ? (
              hydtList.map((item, index) => {
                return HomeContext.state.isMobile ? (
                  <li
                    className="clearfix"
                    onClick={toRouter.bind(this, 'detail', item)}
                  >
                    <span>
                      <b></b>
                      <div>{item.title}</div>
                    </span>
                  </li>
                ) : (
                  <Tooltip placement="top" title={item.title} key={index}>
                    <li
                      className="clearfix"
                      // onClick={toRouter.bind(this, 'detail', item)}
                    >
                      <span>
                        <b></b>
                        {/* <div>{item.title}</div> */}
                        <a className='newsAA'
                          href={
                            item.link_url
                              ? item.link_url
                              : `/detail?title=hyfc/hydt&id=${item.id}&cid=${item.cid}`
                          }
                          dangerouslySetInnerHTML={{ __html: item.title }}
                        >
                        </a>
                      </span>
                    </li>
                  </Tooltip>
                );
              })
            ) : (
              <Skeleton active paragraph={{ rows: 8 }} />
            )}
          </ul>

          <div className="title clearfix">
            <div>快捷导航</div>
          </div>
          <ul className="kjdh">
            <li onClick={toQuick.bind(this, 'sjdxhxxshrjndh')}>
              <img src={require('@/assets/home/main3(1).png').default} alt="" />
            </li>
            <li onClick={toQuick.bind(this, 'jsxxtxhykxjsj')}>
              <img src={require('@/assets/home/main3(2).png').default} alt="" />
            </li>
            <li onClick={toQuick.bind(this, 'qnxslt')}>
              <img src={require('@/assets/home/main3(3).png').default} alt="" />
            </li>
            <li onClick={toQuick.bind(this, 'lwzj')}>
              <img src={require('@/assets/home/main3(4).png').default} alt="" />
            </li>
            <li onClick={toQuick.bind(this, 'jrxh')}>
              <img src={require('@/assets/home/main3(5).png').default} alt="" />
            </li>
          </ul>

          <div className="title clearfix">
            <div>关于学会</div>
          </div>
          <ul className="gyxh clearfix">
            <li onClick={toId.bind(this, 'xhjj')}>
              <img src={require('@/assets/home/jianjie.png').default} alt=''></img>
              <div>学会简介</div>
            </li>
            <li onClick={toId.bind(this, 'xhzc')}>
              <img src={require('@/assets/home/zhangcheng.png').default} alt=''></img>
              <div>学会章程</div>
            </li>
            <li onClick={toId.bind(this, 'zzjg')}>
              <img src={require('@/assets/home/zuzhijiagou.png').default} alt=''></img>
              <div>组织架构</div>
            </li>
            <li onClick={toId.bind(this, 'lshmd')}>
              <img src={require('@/assets/home/dongshihui.png').default} alt=''></img>
              <div>理事会名单</div>
            </li>
            <li onClick={toId.bind(this, 'jshmd')}>
              <img src={require('@/assets/home/dongshihui.png').default} alt=''></img>
              <div>监事会名单</div>
            </li>
            <li onClick={toId.bind(this, 'fzjg')}>
              <img src={require('@/assets/home/fenzhi.png').default} alt=''></img>
              <div>分支机构</div>
            </li>
            <li onClick={toId.bind(this, 'dsxh')}>
              <img src={require('@/assets/home/xuehui.png').default} alt=''></img>
              <div>地市学会</div>
            </li>
            <li onClick={toId.bind(this, 'ddjs')}>
              <img src={require('@/assets/home/dang.png').default} alt=''></img>
              <div>党的建设</div>
            </li>
            <li onClick={toId.bind(this, 'glbf')}>
              <img src={require('@/assets/home/guanli.png').default} alt=''></img>
              <div>管理办法</div>
            </li>
            <li onClick={toId.bind(this, 'hydw')}>
              <img
                src={require('@/assets/home/huiyuandanwei.png').default}
                alt=""
              ></img>
              <div>会员单位</div>
            </li>
            <li onClick={toId.bind(this, 'lxwm')}>
              <img src={require('@/assets/home/lianxiwomen.png').default} alt=''></img>
              <div>联系我们</div>
            </li>
          </ul>
        </div>
      </div>
      <div className="btmMenu center">
        <div>
          <i></i>
          <b>快速导航</b>
          <Select
            defaultValue="国内通信相关网站"
            style={{ width: 170 }}
            onChange={handleChange}
          >
            {linksData1 &&
              linksData1.map((item, index) => {
                return (
                  <Option key={index} value={item.url}>
                    {item.title}
                  </Option>
                );
              })}
          </Select>
          <Select
            defaultValue="省内相关网站"
            style={{ width: 170 }}
            onChange={handleChange}
          >
            {linksData2 &&
              linksData2.map((item, index) => {
                return (
                  <Option key={index} value={item.url}>
                    {item.title}
                  </Option>
                );
              })}
          </Select>
          <Select
            defaultValue="其他相关网站"
            style={{ width: 170 }}
            onChange={handleChange}
          >
            {linksData3 &&
              linksData3.map((item, index) => {
                return (
                  <Option key={index} value={item.url}>
                    {item.title}
                  </Option>
                );
              })}
          </Select>
        </div>
      </div>
    </div>
  );
}
export default Home;
